import "./About.module.css";
import Header from "@/reusable_sections/Header";
import AboutHero from "./sections/AboutHero";
import WhatMakesUsDifferent from "./sections/WhatMakesUsDifferent";
import MeetTheFounder from "./sections/MeetTheFounder";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <AboutHero />
      <MeetTheFounder />
      <WhatMakesUsDifferent />
      <CallToAction />
      <Footer />
    </div>;
}